import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user';
import print from './modules/print';
import axios from 'axios'

const fb = require('@/firebase/config.js');

Vue.use(Vuex)


export const store = new Vuex.Store({
    modules: {
        user,
        print
    },
    state: {
        orders: []
    },
    mutations: {
        setInitApp(state, payload) {
            console.log('initializedApp ', payload)
            state.initializedApp = payload;
        },
        setOrders(state, payload) {
            state.orders = payload;
        },
        toggleOrderCompleted(state, order) {
            let index = state.orders.findIndex(item => item.id === order.id);
            Vue.set(state.orders[index].data, 'completed', !state.orders[index].data.completed);
        },
        setOrderProductionState(state, payload) {
            const order = payload.order
            const productionState = payload.state
            let index = state.orders.findIndex(item => item.id === order.docId);
            Vue.set(state.orders[index].data, 'production', productionState);
        },
        deleteOrder(state, order) {
            // let index = state.orders.findIndex(item => item.id === order.id);
            state.orders = state.orders.filter((item => item.id !== order.id))
            // Vue.set(state.orders[index].data, 'completed', !state.orders[index].data.completed);
        }
    },
    actions: {
        toggleOrderCompleted({commit}, order) {
            return new Promise((resolve, reject) => {
                fb.ordersCollection
                    .doc(order.id)
                    .set({completed: !order.data.completed}, {merge: true})
                    .then(() => {

                        commit('toggleOrderCompleted', order);
                        resolve(true);

                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        setOrderProduced({commit}, orderId) {
            // eslint-disable-next-line
            return new Promise(async (resolve, reject) => {
                const order = await fb.ordersCollection
                  .where('orderId', '==', orderId)
                  .limit(1)
                  .get()
                  .then((snapshot) => {
                      if (snapshot.empty) {
                          return null
                      } else {
                          return {
                              docId: snapshot.docs[0].id,
                              data: snapshot.docs[0].data()
                          }
                      }
                  })

                console.log('found order', order)

                if (order === null) {
                     reject('order not found')
                    return
                }
                const productionState = {
                    finished: true,
                    date: new Date()
                }

                await fb.ordersCollection
                    .doc(order.docId)
                    .set({production: productionState}, {merge: true})
                    .then(() => {
                        const obj = {
                            order,
                            state: productionState
                        }
                        commit('setOrderProductionState', obj);
                        resolve(obj);

                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        deleteOrder({commit}, order) {
            return new Promise((resolve, reject) => {
                fb.ordersCollection
                    .doc(order.id)
                    .delete()
                    .then(() => {

                        commit('deleteOrder', order);
                        resolve(true);

                    })
                    .catch((error) => {
                        reject(error);
                    })
            })
        },
        getFiles({commit}, payload) {
            return new Promise((resolve, reject) => {
                var orders = [];

                if (payload.smb) {
                    axios.get(payload.url)
                      .then((result) => {
                          console.log('result forom axios', result.data)

                          let orders = []
                          result.data.forEach((item) => {
                              let obj = {
                                  completed: false,
                                  created: item.CaptureDateUtcTimeStamp * 1000,
                                  files: {
                                      org: {
                                          url: item.FileUrl,
                                          path: ''
                                      },
                                      print: {
                                          url: item.FileUrl,
                                          path: ''
                                      }
                                  },
                                  metadata: {
                                      city: '',
                                      country: '',
                                      email: '',
                                      firstname: 'smb',
                                      lastname: '',
                                      newslettter: false,
                                      phone: '',
                                      price: "6.70",
                                      quantity: 1,
                                      street: '',
                                      total: "10",
                                      ua: '',
                                      uid: 'smb',
                                      zip: ''
                                  },
                                  name: ''
                              }
                              orders.push({ id: item.MediaId, data: obj })
                          })

                          commit('setOrders', orders);
                          resolve(orders);

                      })
                } else {
                    fb.ordersCollection
                      .orderBy("created", "desc")
                      .get()
                      .then((docs) => {
                          docs.docs.forEach((item) => {
                              const orderData = item.data()
                              if (!orderData.order) {
                                  orderData.order = { orderId: '?', orderNo: 0 }
                              }
                              orders.push({id: item.id, data: orderData});
                              console.log(item.data())
                          });

                          commit('setOrders', orders);
                          resolve(orders);

                      })
                      .catch((error) => {
                          reject(error);
                      })
                }


            })
        },
        uploadFile({commit}, payload) {
            return new Promise((resolve, reject) => {
                console.log('store', payload.data);

                const now = Date.now();
                const rand = Math.random().toString(36).substring(7);
                const filename = `${fb.auth.currentUser.uid}_${now}_${rand}_${payload.file.name}`

               const path = `files2023/${fb.auth.currentUser.uid}/${filename}`;
               const metadata ={ customMetadata: {...payload.metadata, uid: fb.auth.currentUser.uid, ua: navigator.userAgent}};

                fb.storage.ref(path).putString(payload.file.dataUrl, 'data_url', metadata)
                    .then((snapshot) => {

                        console.log('uploaded file', snapshot);

                        resolve();

                        commit('xx', payload.file)

                    })
                    .catch((error) => {
                        reject(error);
                    })

            })
        },
    },
})
